import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import { Link } from 'react-router-dom';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

const CalculationsUnitsLoadData = props => {
  const {
    handleClickMenuItem,
    periodId
  } = props;
  return (
    <div className="load_data_section calculate_units_load_data_wrapper">
      <h3>{LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.loadDataTitleCalculationUnits"/>)}</h3>
      <Link data-route={Constants.app.routes.calculationUnitAdmin} to={Constants.app.routes.calculationUnitAdmin + "/" + periodId} onClick={handleClickMenuItem}>
        {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.calculationUnitsLink"/>)}
      </Link>
    </div>
  );
};

export default CalculationsUnitsLoadData;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculationsUnitsLoadData.jsx